import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarHeader,
  SidebarFooter,
} from "components/ui/sidebar";
import {
  LayoutDashboard,
  Users,
  Truck,
  PlugZap,
  Megaphone,
  ScrollText,
  Kanban,
  UserCog,
  FileClock,
  BarChart3,
  LogOut,
  ShieldCheck,
  LifeBuoy,
  Wallet,
  Landmark,
} from "lucide-react";
import NavLink from "components/NavLink";
import { useNavigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "hooks/useAdminAuth";
import { adminPaths } from "app/paths";

const NAV_ITEMS = [
  { path: adminPaths.dashboard, label: "Dashboard", icon: <LayoutDashboard /> },
  { path: adminPaths.clientes, label: "Clientes", icon: <Users /> },
  { path: adminPaths.envios, label: "Envios", icon: <Truck /> },
  { path: adminPaths.chamados, label: "Chamados", icon: <LifeBuoy /> },
  { path: adminPaths.carteira, label: "Carteira", icon: <Wallet /> },
  { path: adminPaths.regimes, label: "Regimes", icon: <Landmark /> },
  { path: adminPaths.integracoes, label: "Integrações", icon: <PlugZap /> },
  { path: adminPaths.comunicacao, label: "Comunicação", icon: <Megaphone /> },
  { path: adminPaths.changelog, label: "Changelog", icon: <ScrollText /> },
  { path: adminPaths.roadmap, label: "Roadmap", icon: <Kanban /> },
  { path: adminPaths.equipe, label: "Equipe", icon: <UserCog /> },
  { path: adminPaths.logs, label: "Logs", icon: <FileClock /> },
  { path: adminPaths.relatorios, label: "Relatórios", icon: <BarChart3 /> },
];

const AdminSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { admin, logout } = useAdminAuth();

  return (
    <Sidebar variant="inset" className="bg-brand-sidebar text-brand-cardtext max-w-[240px]">
      <SidebarHeader>
        <div className="flex items-center gap-2 px-2 py-1 text-brand-cardtext">
          <ShieldCheck className="w-6 h-6 text-brand-secondary" />
          <div className="leading-tight">
            <p className="text-shopify-body font-semibold">Intrex Admin</p>
            <p className="text-shopify-caption text-brand-light_text">Centro de Operações</p>
          </div>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel className="mb-2">Operação</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu className="gap-2">
              {NAV_ITEMS.map((item) => (
                <NavLink
                  key={item.path}
                  icon={item.icon}
                  name={item.label}
                  active={location.pathname === item.path || location.pathname.startsWith(`${item.path}/`)}
                  action={() => navigate(item.path)}
                />
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter className="mb-4">
        <SidebarMenu className="gap-2">
          <NavLink
            icon={<UserCog />}
            name={admin?.name || "Admin"}
            action={() => navigate(adminPaths.equipe)}
          />
          <NavLink
            icon={<LogOut />}
            name="Sair"
            action={async () => {
              await logout();
              navigate(adminPaths.login, { replace: true });
            }}
          />
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  );
};

export default AdminSidebar;
